import { render, staticRenderFns } from "./publishTopic.vue?vue&type=template&id=447fed6c&scoped=true"
import script from "./publishTopic.vue?vue&type=script&lang=js"
export * from "./publishTopic.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/publishTopic.css?vue&type=style&index=0&id=447fed6c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447fed6c",
  null
  
)

export default component.exports